import { mapState } from 'vuex'
import debounce from 'lodash-es/debounce'
import SearchSessionStorageMixin from './SearchSessionStorage'

const OriginMixin = {
  computed: {
    ...mapState('eHorizonSearchForm', ['origin'])
  },
  mixins: [SearchSessionStorageMixin],
  methods: {
    onOriginFocused() {
      this.showOriginTypeahead()
    },
    originCloseAll() {
      this.$store.dispatch('eHorizonSearchForm/origin/closeTypeahead')
    },
    showOriginTypeahead() {
      this.$store.commit('eHorizonSearchForm/origin/typeahead/open')
    },
    onOriginFilter: debounce(function (value) {
      this.$store.dispatch('eHorizonSearchForm/origin/doFilter', value)
    }, 0),
    onOriginOpenUpdate(openBl) {
      if (!openBl && this.origin.typeahead.open) {
        this.originCloseAll()
      }
    },
    onOriginSelect(originValue, updateSession = false, resetSession = false) {
      this.$store.dispatch('eHorizonSearchForm/selectOrigin', originValue)

      if (updateSession) {
        this.$_searchSessionStorageMixin_updateOriginSessionStorage(resetSession)
      }
    },
    onOriginLabelUpdate(label) {
      this.$store.dispatch('eHorizonSearchForm/origin/setSelectedLabel', label)
    }
  }
}
export default OriginMixin
